function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers) {
    var h = require("panel").h;
    return {
      value: (h("div", {
        "class": {
          'visibility-controls': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'visibility-controls-container': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-checkbox", {
              "attrs": {
                checked: $attr(`hidden-value`),
                disabled: $attr(`hidden-disabled`)
              },
              "on": {
                click: $attr(`hidden-disabled`) ? null : $helpers.handleClickHidden
              },
              "class": {
                'visibility-controls-checkbox': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Hide from menus but share via direct link");
              __jade_nodes = __jade_nodes.concat(($attr(`hidden-disabled`)) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-tooltip", (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat($helpers.getTooltipText());;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) : undefined);;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'visibility-controls-container': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-checkbox", {
              "attrs": {
                checked: $attr(`locked-value`),
                disabled: $attr(`locked-disabled`)
              },
              "on": {
                click: $attr(`locked-disabled`) ? null : $helpers.handleClickLocked
              },
              "class": {
                'visibility-controls-checkbox': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Prevent editing of this " + ($attr(`entity-type`)) + "");
              __jade_nodes = __jade_nodes.concat((!$attr(`locked-disabled`)) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'visibility-controls-info-tooltip': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                    "attrs": {
                      icon: `info`
                    },
                  }));
                  __jade_nodes = __jade_nodes.concat(h("mp-tooltip", (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat("Project owners will always be able to edit " + ($attr(`entity-type-plural`)) + "");;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) : undefined);;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(($attr(`locked-disabled`)) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-tooltip", (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat($helpers.getTooltipText());;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) : undefined);;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;